class CustomFilterSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderMin = this.querySelector('[data-slider-min]');
    this.sliderMax = this.querySelector('[data-slider-max]');
    this.minInput = this.querySelector('[data-min-input]');
    this.maxInput = this.querySelector('[data-max-input]');
    this.hiddenInputsContainer = this.querySelector('[data-hidden-inputs]');
    this.sliderTrack = this.querySelector('[data-slider-track]');
    this.filterParam = this.dataset.filterParam;
    this.blockId = this.dataset.blockId;

    if (this.sliderMin && this.sliderMax) {
      this.availableValues = this.sliderMin.dataset.availableValues
        .split(',')
        .map(v => parseFloat(v))
        .sort((a, b) => a - b);

      this.minValue = parseFloat(this.sliderMin.min);
      this.maxValue = parseFloat(this.sliderMax.max);

      this.init();
    }
  }

  init() {
    this.sliderMin.addEventListener('input', (e) => {
      const minVal = parseFloat(e.target.value);
      const maxVal = parseFloat(this.sliderMax.value);
      if (minVal > maxVal) {
        this.sliderMin.value = maxVal;
      }
      this.updateDisplay();
    });

    this.sliderMax.addEventListener('input', (e) => {
      const minVal = parseFloat(this.sliderMin.value);
      const maxVal = parseFloat(e.target.value);
      if (maxVal < minVal) {
        this.sliderMax.value = minVal;
      }
      this.updateDisplay();
    });

    this.sliderMin.addEventListener('change', () => {
      this.updateFilters();
    });

    this.sliderMax.addEventListener('change', () => {
      this.updateFilters();
    });

    if (this.minInput) {
      this.minInput.addEventListener('change', (e) => {
        let value = parseFloat(e.target.value);
        value = Math.max(this.minValue, Math.min(parseFloat(this.sliderMax.value), value));
        this.sliderMin.value = value;
        this.updateDisplay();
        this.updateFilters();
      });
    }

    if (this.maxInput) {
      this.maxInput.addEventListener('change', (e) => {
        let value = parseFloat(e.target.value);
        value = Math.max(parseFloat(this.sliderMin.value), Math.min(this.maxValue, value));
        this.sliderMax.value = value;
        this.updateDisplay();
        this.updateFilters();
      });
    }

    this.updateDisplay();
  }

  updateDisplay() {
    const minVal = parseFloat(this.sliderMin.value);
    const maxVal = parseFloat(this.sliderMax.value);

    if (this.minInput) {
      this.minInput.value = Math.round(minVal);
    }

    if (this.maxInput) {
      this.maxInput.value = Math.round(maxVal);
    }

    const rangeMin = ((minVal - this.minValue) / (this.maxValue - this.minValue)) * 100;
    const rangeMax = ((maxVal - this.minValue) / (this.maxValue - this.minValue)) * 100;

    if (this.sliderTrack) {
      this.sliderTrack.style.setProperty('--range-min', `${rangeMin}%`);
      this.sliderTrack.style.setProperty('--range-max', `${rangeMax}%`);
    }
  }

  updateFilters() {
    const minVal = parseFloat(this.sliderMin.value);
    const maxVal = parseFloat(this.sliderMax.value);

    this.hiddenInputsContainer.innerHTML = '';

    this.availableValues.forEach(value => {
      if (value >= minVal && value <= maxVal) {
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.name = `${this.filterParam}__${this.blockId}`;
        checkbox.value = value;
        checkbox.checked = true;
        checkbox.className = 'visually-hidden';
        checkbox.setAttribute('data-filter-checkbox', '');
        checkbox.setAttribute('data-block-id', this.blockId);
        checkbox.setAttribute('data-base-param', this.filterParam);
        this.hiddenInputsContainer.appendChild(checkbox);
      }
    });

    this.closest('facet-filters-form')?.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

if (!customElements.get('custom-filter-slider')) {
  customElements.define('custom-filter-slider', CustomFilterSlider);
}
